import styled from 'styled-components';

export const BookedAppointmentsWrapper = styled.div``;

export const AvailableServicesWrapper = styled.div`
	padding-top: ${(props) => props.theme.spacing['2']};
`;

export const AvailableServicesList = styled.div``;
